import { MotiusAnulacioFilterComponent } from './../../components/motius-anulacio-filter/motius-anulacio-filter.component';
import { Component, OnInit, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { MotiusAnulacioFilter } from '../../models/motius-anulacio-filter';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { PermissionDialogComponent } from 'path-shared/components/permission-dialog/permission-dialog.component';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { Builder } from 'path-shared/models/builder';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { NotificationService } from 'path-shared/services/notification/notification.service';
import { MotiusAnulacioTableComponent } from '../../components/motius-anulacio-table/motius-anulacio-table.component';
import { MotiusAnulacioEditorComponent } from '../../components/motius-anulacio-editor/motius-anulacio-editor.component';

@Component({
  selector: 'app-motius-anulacio',
  templateUrl: './motius-anulacio.component.html',
  styleUrls: ['./motius-anulacio.component.scss']
})
export class MotiusAnulacioComponent implements OnInit, AfterViewInit {

  permissionDialogRef: MatDialogRef<PermissionDialogComponent>;
  activeFilters: string[] = [];
  filterData: MotiusAnulacioFilter;
  somIdFoo: number;
  tipusMatricules = Array();
  dataDialog: ComponentDialog = Builder.newComponentDialog();

  @ViewChild(MotiusAnulacioTableComponent) motiusAnulacioTable: MotiusAnulacioTableComponent;

  constructor(
    private dialog: MatDialog,
    public auth: AuthorizationService,
    private i18n: I18n,
    private not: NotificationService,
    public thisDialogRef: MatDialogRef<MotiusAnulacioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.filterData = new MotiusAnulacioFilter('id', 'desc');
      if (data !== undefined) {
        this.dataDialog = data;
      }
    }

  ngOnInit(): void {
    this.auth.UserCanSeePage(this.auth.Pages.MotiusAnulacio);
    this.motiusAnulacioTable.itemClicked.subscribe(secure_id => {
      this.update(secure_id);
    });
    this.motiusAnulacioTable.itemSelected.subscribe(codi => {
      this.thisDialogRef.close(codi);
    });
  }

  ngAfterViewInit() {
    if (!this.dataDialog.isDialog) {
      this.not.titleChange(this.i18n('Motius Anul·lació'));
    }
  }

  edit() {
    const idSeleccionat: string = this.motiusAnulacioTable.displayedItems['checkedItems'][0];
    this.update(idSeleccionat);
  }

  create() {
    this.update(null);
  }

  update(secure_id: string) {
    const data: ComponentDialog = Builder.newComponentDialog(true, false, secure_id);

    const ref = this.dialog.open(MotiusAnulacioEditorComponent, {
      width: '70%',
      closeOnNavigation: false,
      autoFocus: true,
      data: data
    });

    ref.afterClosed().subscribe(updated => {
      if (updated) { this.motiusAnulacioTable.load(); }
    });
  }

  refresh() {
    this.motiusAnulacioTable.load();
  }

  onFilterClicked() {
    const ref = this.dialog.open(MotiusAnulacioFilterComponent, {
      width: '50%',
      closeOnNavigation: false,
      autoFocus: true,
      data: {
        'filter': this.motiusAnulacioTable.filter
      }
    });

    ref.componentInstance.notify.subscribe((filter: MotiusAnulacioFilter) => {
      this.motiusAnulacioTable.filter.set(filter);
      this.motiusAnulacioTable.load();
    });
  }

  onRowSelected(somid) {
    this.update(somid);
  }

  generateExcel() {
    this.motiusAnulacioTable.generateExcel();
  }

}
